export const styles = theme => ({
    description: {
        height: 70
    }
});
